import { useCubeQuery } from '@cubejs-client/react';
import { LabelOutlined } from '@mui/icons-material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { DimCommodityGroupField } from '~/common/types/cubes/DimCommodityGroup';
import { BaseDetailHeader, BaseDetailHeaderProps } from '~/components/BaseDetailHeader/BaseDetailHeader';

import { Description } from './CommodityGroupDetailHeader.styled';

export interface CommodityGroupDetailHeaderProps {
  id: string;
  tabs?: BaseDetailHeaderProps['tabs'];
  actionsRight?: ReactNode;
}

export const CommodityGroupDetailHeader = ({ id, tabs, actionsRight }: CommodityGroupDetailHeaderProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'CommodityGroupDetail' });

  const { resultSet, isLoading } = useCubeQuery({
    dimensions: [DimCommodityGroupField.NAME, DimCommodityGroupField.DESCRIPTION],
    filters: [{ member: DimCommodityGroupField.ID, operator: 'equals', values: [id] }],
  });

  const row = resultSet?.rawData()?.[0];
  const name = (row?.[DimCommodityGroupField.NAME] as string) ?? '';
  const description = (row?.[DimCommodityGroupField.DESCRIPTION] as string) ?? '';

  return (
    <BaseDetailHeader
      loading={isLoading}
      title={t('title', { id: name })}
      tabs={tabs}
      links={[]}
      actionsRight={actionsRight}
      center={
        <Description variant="body2" color="textPrimary" startIcon={<LabelOutlined fontSize="small" />}>
          {description}
        </Description>
      }
    />
  );
};
